/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
require("../plugins/plugins");

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('oembed', require('./components/OembedComponent'));

if (document.getElementById("vue-app") || document.getElementById("app")) {
    const app = new Vue({
        el: document.getElementById("vue-app") || document.getElementById("app"),
        data() {
            return {
                searchPage: 1,
            };
        },
        methods: {
            infiniteSearchHandler($state, searchQuery) {
                this.searchPage++;
                let url =
                    location.pathname +
                    "?s=" +
                    encodeURIComponent(searchQuery) +
                    "&page=" +
                    this.searchPage;
                axios
                    .get(url)
                    .then((result) => {
                        let articles = $(result.data).find(
                            ".search-results article"
                        );

                        if (articles.length) {
                            $(".search-results").append(articles);

                            $state.loaded();
                        } else {
                            $state.complete();
                        }
                    })
                    .catch((err) => {
                        console.log("ERROR INFINITE LOADING", err);
                    });
            },
        },
    });
}

/*
 ** With Slick Slider Plugin : https://github.com/marvinhuebner/slick-animation
 ** And Slick Animation Plugin : https://github.com/marvinhuebner/slick-animation
 */

var slideWrapper = $(".main-slider"),
    iframes = slideWrapper.find(".embed-player"),
    lazyImages = slideWrapper.find(".slide-image"),
    lazyCounter = 0;

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command) {
    if (player == null || command == null) return;
    return player.contentWindow.postMessage(JSON.stringify(command), "*");
}

// When the slide is changing
function playPauseVideo(slick, control) {
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.data("media-type");
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");

    if (slideType === "vimeo") {
        switch (control) {
            case "play":
                if (
                    startTime != null &&
                    startTime > 0 &&
                    !currentSlide.hasClass("started")
                ) {
                    currentSlide.addClass("started");
                    postMessageToPlayer(player, {
                        method: "setCurrentTime",
                        value: startTime,
                    });
                }
                postMessageToPlayer(player, {
                    method: "play",
                    value: 1,
                });
                break;
            case "pause":
                postMessageToPlayer(player, {
                    method: "pause",
                    value: 1,
                });
                break;
        }
    } else if (slideType === "youtube") {
        // console.log(11111111111, postMessageToPlayer(player, {
        //     "event": "command",
        //     "func": "setPlaybackQuality",
        //     "args": ["small"]
        // }));

        switch (control) {
            case "play":
                postMessageToPlayer(player, {
                    event: "command",
                    func: "mute",
                });
                postMessageToPlayer(player, {
                    event: "command",
                    func: "playVideo",
                });
                $(player).removeClass("hidden");
                break;
            case "pause":
                postMessageToPlayer(player, {
                    event: "command",
                    func: "pauseVideo",
                });
                break;
        }
    } else if (slideType === "video") {
        video = currentSlide.children("video").get(0);
        if (video != null) {
            if (control === "play") {
                video.play();
            } else {
                video.pause();
            }
        }
    }
}

// Resize player
function resizePlayer(iframes, ratio) {
    var win = slideWrapper,
        width = win.width(),
        playerWidth,
        height = win.height(),
        playerHeight,
        ratio = ratio || 16 / 9;

    if (iframes[0]) {
        iframes.each(function () {
            var current = $(this);
            if (width / ratio < height) {
                playerWidth = Math.ceil(height * ratio);
                current
                    .width(playerWidth)
                    .height(height)
                    .css({
                        left: (width - playerWidth) / 2,
                        top: 0,
                    });
            } else {
                playerHeight = Math.ceil(width / ratio);
                current
                    .width(width)
                    .height(playerHeight)
                    .css({
                        left: 0,
                        top: (height - playerHeight) / 2,
                    });
            }
        });
    }

    slideWrapper.find(".video").height(height);
}

// DOM Ready
$(function () {
    if (slideWrapper.slick) {
        // Initialize slider
        slideWrapper.on("init", function (slick) {
            slick = $(slick.currentTarget);

            $(iframes).removeClass("hidden");
            slick.find("video").removeClass("hidden");
            slick.find("video").hei;

            resizePlayer(iframes, 16 / 9);

            setTimeout(function () {
                playPauseVideo(slick, "play");
            }, 500);

            setTimeout(function () {
                playPauseVideo(slick, "play");
            }, 1000);
        });
        slideWrapper.on("beforeChange", function (event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, "pause");
        });
        slideWrapper.on("afterChange", function (event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, "play");
        });
        slideWrapper.on(
            "lazyLoaded",
            function (event, slick, image, imageSource) {
                lazyCounter++;
                if (lazyCounter === lazyImages.length) {
                    lazyImages.addClass("show");
                    // slideWrapper.slick("slickPlay");
                }
            }
        );

        //start the slider
        slideWrapper
            .slick({
                fade: true,
                autoplaySpeed: 20000,
                lazyLoad: "progressive",
                speed: 700,
                arrows: true,
                dots: true,
                autoplay: true,
                cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)",
            })
            .slickAnimation();
    }

    // let node = $('.text-content-wysiwyg *').first();
    // if (node[0].nodeName == 'P' && (node.html() == "&nbsp;" || node.text() == '')) {
    //     node.remove();
    // }

    $("form.check-tos").each((index, form) => {
        function checkValid() {
            let tosChecked = $(form).find(".tos-input").is(":checked"); // check if checked

            $(form).find(".btn-submit").prop("disabled", !tosChecked);
        }

        checkValid(form); // run it for the first time
        $(form).find(".tos-input").on("change", checkValid); // bind checkbox
    });

    $(".data-filter-item input[type='radio']").on("change", function (e) {
        $("input[name='" + $(this).attr("name") + "']")
            .parent()
            .removeClass("active");
        $(this).parent().addClass("active");

        // $("div[data-radio-filter='" + $(this).attr('name') + "']:not([data-radio-filter-show='" + $(this).val() + "'])").hide();
        // $("div[data-radio-filter='" + $(this).attr('name') + "'][data-radio-filter-show='" + $(this).val() + "']").show();
        //
        // $(".group-list .group-item").matchHeight({
        //     byRow: false,
        // });
    });

    $(".data-filter-item").on("click", function (e) {
        if (e.ctrlKey) {
            $(this).find("input[type='radio']").prop("checked", false);
            $(this).find("label").removeClass("active");

            // $("div[data-radio-filter='" + $(this).find("input[type='radio']").attr('name') + "']")
            //     .show();

            $(".group-list .group-item").matchHeight({
                byRow: true,
            });
        }
    });
});

// Resize event
$(window).on("resize.slickVideoPlayer", function () {
    resizePlayer(iframes, 16 / 9);
});


document.addEventListener("alpine:init", () => {
    console.log('Alpine initialized');
    Alpine.data("vue", () => ({
        vueRoot: null,
        vueApp: null,
        init() {
            this.vueRoot = this.$el.querySelector('.vue-root');
            console.log('Alpine init vue component', this.vueRoot);

            this.vueApp = new Vue({
                el: this.vueRoot,
            });
        },
    }));
});